import { Component, Inject, SimpleChanges, Renderer2, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TenderService } from '../../_services/tender.service';
import { Title, Meta } from '@angular/platform-browser';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';
import { environment } from 'src/environments/environment';
import { DOCUMENT } from '@angular/common';
import { Subscription } from 'rxjs';

import { webSiteschemaService } from 'src/app/modules/shared/_services/website-schema.service';
import { StripMarginService } from 'src/app/modules/shared/_services/strip-margin.service';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';

@Component({
  selector: 'app-keywords-list',
  templateUrl: './keywords-list.component.html',
  styleUrls: ['./keywords-list.component.scss']
})
export class KeywordsListComponent {
  activeSection: string = "primarButton";
  statesList: Array<any> = [];
  subscription: Subscription = new Subscription();
  stripMargin: boolean = true;
  daysLeft: any;
  shouldShowTrialBanner: boolean = false;
  constructor(private tenderService: TenderService, private activatedRoute: ActivatedRoute,private stripMarginService: StripMarginService,
    private renderer2: Renderer2, private meta: Meta, private sharedService: SharedService, public router: Router,private webSiteschema: webSiteschemaService
    ,@Inject(DOCUMENT) private document: any, private title: Title, private cdr: ChangeDetectorRef, private authService: AuthService // Inject ChangeDetectorRef
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['paramsData']) {
      this.paramsData = this.activatedRoute.snapshot.paramMap.get('third');
      this.resolveTenderList(this.paramsData);
      this.setMetas(this.paramsData);
      this.cdr.detectChanges(); // Ensure changes are detected
    }
  }


  /**
   * Navigate to tenders page with full page reload
   * This bypasses Angular's internal routing and triggers a full page reload
   * to pull fresh data from the CDN instead of using cached data
   */
  navigate(event: MouseEvent, link: string): void {
    // Prevent the default anchor behavior
    event.preventDefault();
    // Use window.location.href to reload the page and pull fresh data from CDN
    window.location.href = `/${link}-tenders/active`;
  }

  paramsData: any;
  ngOnInit(): void {
    this.stripMarginService.stripMargin$.subscribe(
      (value) => {
        this.stripMargin = value;
      }
    );
    // Subscribe to route parameter changes
    this.subscription.add(
      this.activatedRoute.paramMap.subscribe(params => {
        this.paramsData = params.get('third');
        this.resolveTenderList(this.paramsData);
        this.setMetas(this.paramsData);
        this.scrollTop();
      })
    );
    this.checkTrialBanner();
  }
  // ngOnInit(): void {
  //   this.paramsData = this.activatedRoute.snapshot.paramMap.get('third');
  //   this.resolveTenderList(this.paramsData);
  //   this.setMetas(this.paramsData);
  //   this.scrollTop();
  // }

  resolveTenderList(paramsData: any) {
    this.tenderService.tenderindexing(paramsData).subscribe((res: any) => {
      this.statesList = res?.data?.summaryList;
      this.groupStatesByAlphabet();
      this.cdr.detectChanges(); // Ensure changes are detected
    });
  }
  alphabets: string[] = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));

  getGroupedStatesKeys(): string[] {
    return Object.keys(this.groupedStates);
  }
  getGroupedStatesEntries(): { key: string, value: any[] }[] {
    return Object.entries(this.groupedStates).map(([key, value]) => ({ key, value }));
  }

  groupedStates: { [key: string]: any[] } = {};
  groupStatesByAlphabet() {
    this.groupedStates = this.statesList.reduce((acc: { [key: string]: any[] }, state: any) => {
      const firstLetter = state.name.charAt(0).toUpperCase();
      acc[firstLetter] = acc[firstLetter] || [];
      acc[firstLetter].push(state);
      return acc;
    }, {});
  }

  filteredStates: any[] = [];

  filterStatesByAlphabet(alphabet: string) {
    this.filteredStates = this.groupedStates[alphabet] || [];
  }

  scrollTop() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }

  isActiveLink: string | null = "";

  setActiveLink(link: string) {
    this.isActiveLink = link;
  }

  scrollToSection(alphabet: string) {
    const element = document.getElementById(`section${alphabet}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: "center" });
    }
  }

  metTitle: any
  metaDescription: any;
  setMetas(paramsData: any) {
    if (paramsData === 'authorities') {
      this.metTitle = "Find All Tenders & E - Procurement by Indian Authorities | TenderShark";
      this.metaDescription = "Explore all Indian tenders and e-procurement opportunities by top authorities. Get the latest e-procurement opportunities from TenderShark to boost your business growth."
    } else if (paramsData === 'states') {
      this.metTitle = "Find Indian State Tenders and E-Procurement Listings at TenderShark | TenderShark";
      this.metaDescription = "Explore state tenders and e-procurement opportunities at TenderShark. Stay updated with the newest e-tender listings by states from various government authorities to enhance your business prospects."
    } else if (paramsData === 'categories') {
      this.metTitle = "Indian Tenders by Categories: Explore Opportunities Across Sectors";
      this.metaDescription = "Explore Indian tenders categorized by sectors like infrastructure, healthcare, IT, and more. Stay ahead in procurement with TenderShark detailed listings and strategic bidding insights.";
    } else if (paramsData === 'procurement') {
      this.metTitle = "Indian Tenders By Procurement Types | Explore Works, Goods, Services | TenderShark";
      this.metaDescription = "Explore Indian tenders categorized by procurement types such as works, goods, and services. Stay informed and streamline your bidding process with comprehensive listings and insights from top procurement portals.";
    } else if (paramsData === 'cities') {
      this.metTitle = "Indian Tenders By Cities | Discover Opportunities at TenderShark | TenderShark";
      this.metaDescription = "Explore Indian tenders categorized by cities on TenderShark. Stay updated with the latest procurement opportunities across various cities in India.";
    } else if (paramsData === 'keywords') {
      this.metTitle = "Find Indian Tenders by Specific Keywords like AC, Bed, CC Road, & More E-Tenders | TenderShark";
      this.metaDescription = "Explore Indian tenders by specific keywords such as Air Conditioner, Bed, CC Road, and more on TenderShark. Stay updated with targeted procurement opportunities across various sectors.";
    }

    this.title.setTitle(this.metTitle);
    if (this.sharedService.isServer) {
      let links = this.renderer2.createElement('link');
      links.rel = 'canonical';
      links.href = environment.TENDER.BASE_URL;
      this.renderer2.appendChild(this.document.head, links);

      const imageUrl = "https://d1tiqtcifmy0l7.cloudfront.net/prod/images/logo/Tender_Shark_logo.webp";

      this.meta.addTag({ "name": "description", "content": this.metaDescription });
      this.meta.addTag({ "name": "og:title", "content": this.metTitle });
      this.meta.addTag({ "name": "og:description", "content": this.metaDescription });
      this.meta.addTag({ "name": "og:site_name", "content": "TenderShark" });
      this.meta.addTag({ "name": "og:type", "content": "website" });
      this.meta.addTag({ "name": "og:url", "content": environment.TENDER.BASE_URL + this.router.url });
      this.meta.addTag({ "name": "og:image", "content": imageUrl });

      this.meta.updateTag({ name: 'twitter:card', content: 'summary' });
      this.meta.updateTag({ name: 'twitter:site', content: '@tender_shark' });
      this.meta.updateTag({ name: 'twitter:title', content: this.metTitle });
      this.meta.updateTag({ name: 'twitter:description', content: this.metaDescription });
      this.meta.updateTag({ name: 'twitter:image', content: imageUrl });
      this.webSiteschema.setWebSiteSchema();
    }
  }

  async checkTrialBanner() {
    const { show } = await this.authService.shouldShowTrialBanner();
    this.shouldShowTrialBanner = show;
  }
}
